var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "nav-slide" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass:
              "challenge-wrapper d-flex justify-content-center align-items-center"
          },
          [
            _c("div", { staticClass: "challenge-content d-flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row align-items-center challenge-ends"
                },
                [
                  _c("InlineSvg", {
                    attrs: { src: "/images/icons/ic-clock.svg" }
                  }),
                  _vm._v("\n\t\t\t\tCHALLENGE ENDS\n\t\t\t")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-row align-items-center" },
                [
                  _c("AppCountdown", {
                    staticClass: "countdown",
                    attrs: { countdownTime: _vm.endDate }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row align-items-center button cursor-pointer",
                  on: { click: _vm.goToChallengeCommunity }
                },
                [
                  _vm._v("\n\t\t\t\tGo to community\n\t\t\t\t"),
                  _c("InlineSvg", {
                    attrs: { src: "/images/icons/ic-chevron-right.svg" }
                  })
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }